import React from 'react'
import { LandingBlockContainer } from '@/components/composed/landingBlocks'
import { InjectHtml } from '@/components/ui'
import type { IOtherConditionsProps } from './interfaces'
import { messages } from './messages'
import './styles.scss'

const LandingOtherConditions: React.FC<IOtherConditionsProps> = props => {
  const { otherConditions, blockId } = props

  return (
    <LandingBlockContainer blockId={blockId} title={messages.title} className="landing-constructor-other-conditions-container">
      <div className="landing-constructor-other-conditions space-holder-top48 space-holder120 space-holder56-sm">
        {otherConditions?.map(text => <InjectHtml html={text} key={text} className="landing-constructor-other-condition" TagName="p" />)}
      </div>
    </LandingBlockContainer>
  )
}

export default LandingOtherConditions
